
<template>
  <div class="content-i">
    <div class="content-box">
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <div class="element-wrapper">
            <h6 class="element-header">Menu Builder</h6>
            <div class="element-box">
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-hamburger-menu-1"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">Menu Builder</h5>
                        <div class="element-inner-desc">Here you can move links between different groups and user levels</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <select class="form-control mb-2" @change="getNavigation()" v-if="userLevels" v-model="currentUserLevel">
                <option value="">Select user level</option>
                <option v-for="level in userLevels" :value="level.id" :key="level.id">{{ level.name }}</option>
              </select>
              <div class="col-12 text-right px-0 mt-3 row mx-0">
                <div class="col-12 px-0 text-right">
                  <span class="btn btn-success text-white" @click="openInstructionsModal()">
                    Instructions <span class="os-icon os-icon-info"></span>
                  </span>
                  <button v-if="!isBusy" class="btn btn-primary" type="submit" @click="updateNavigation()" :disabled="navigationArray.length == 0">Save Navigation</button>
                  <b-button v-if="isBusy" class="btn btn-primary" variant="primary" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    Save Navigation
                  </b-button>
                </div>
              </div>
              <MenuBuilderInstructionsModal ref="menuBuilderInstructions"></MenuBuilderInstructionsModal>
              <hr>
              <div v-if="navigationArray" class="row mb-2">
                <div class="col-8" v-if="currentUserLevel">
                <h5 class="element-inner-header">Active</h5>
                <draggable class="col-12 my-2 list-group bg-warning p-2" :list="parentActiveNavigation" group="parent" v-bind="dragOptions">
                  <button
                    class="btn btn-primary whitespace btn-subnavigation list-group-item my-1 ml-0 mr-2"
                    v-bind:class="[selectedKeys.includes(value.item_key) ? 'btn-success' : 'btn-primary']"
                    v-for="(value,key) in parentActiveNavigation" :key="key"
                    @click.self="displaySubNavigation(value.item_key, value.id)"
                  >
                    {{ t(value.item_key, value.item_key) }}
                    <span class="os-icon os-icon-x" style="color: white" @click="deleteLink(value.id, value.item_key)"></span>
                  </button>
                </draggable>
                </div>
                <div class="col-4" v-if="currentUserLevel">
                  <h5 class="element-inner-header">Inactive</h5>
                <draggable class="col-12 my-2 list-group bg-warning p-2" :list="parentInactiveNavigation" group="parent" v-bind="dragOptions">
                  <button
                    class="btn btn-danger whitespace list-group-item my-1 ml-0 mr-2"
                    v-for="(value,key) in parentInactiveNavigation" :key="key"
                  >
                    {{ t(value.item_key, value.item_key) }}
                   <span class="os-icon os-icon-x" style="color: white" @click="deleteLink(value.id, value.item_key)"></span>
                  </button>
                </draggable>
                </div>
              </div>
              <div class="row">
               <div class="col-12 text-right">
                  <NewParentNavigationModal ref="newParentLinkModal" :userLevels="userLevels"></NewParentNavigationModal>
                  <button class="btn btn-primary" @click="openNewParentModal()" v-if="currentUserLevel">Create New Parent Link</button>
               </div>
              </div>
            </div>
            <div class="row text-left">
              <ResponseInfo class="mb-3" v-if="getResponseInfo.responseName == 'menuBuilder'" />
            </div>
            <div class="element-wrapper" v-if="importNavBox">
              <h6 class="element-header">Import Links</h6>
              <div class="col-12 element-box">
                <div class="element-info">
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-8">
                      <div class="element-info-with-icon">
                        <div class="element-info-icon">
                          <span class="os-icon os-icon-download"></span>
                        </div>
                        <div class="element-info-text">
                          <h5 class="element-inner-header">Import Links</h5>
                          <div class="element-inner-desc">Drag and Drop links from this box to desired navigation</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <select class="form-control mb-2" @change="importNavigation($event)" v-if="userLevels" v-model="importUserLevel">
                  <option :value="null">Select user level</option>
                  <option v-for="level in userLevels" :value="level.id" :key="level.id">{{ level.name }}</option>
                </select>
                <hr>
                <div v-if="importNavigationArray" class="row mb-2">
                  <div v-for="(value, key) in importNavigationArray" class="col-2 mb-3" :key="key">
                    <button class="btn btn-block btn-primary btn-import" @click="displayImportNavigation($event, key, value.id)">{{ t(key, key) }}</button>
                  </div>
                </div>
                <div class="col-12 text-right px-0">
                  <button class="btn btn-danger" @click="closeImportBox()">Close</button>
                </div> 
              </div>
            </div>
            <div>
              <MenuNested :navigation1="nav1" :navigation2="nav2" :title1="selectedKeys[0]" :title2="selectedKeys[1]" :parentId1="parentId1" :parentId2="parentId2" :importNavigation="importNav" :activeParents="parentActiveNavigation" :inactiveParents="parentInactiveNavigation" :userLevelName="importUserLevelName" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteLinkConfrimationModal ref="deleteLinkModal" :navLinkId="navLinkId" :navLinkName="navLinkName"></DeleteLinkConfrimationModal>
    <div v-if="overlayActive" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import MenuNested from "@/views/MenuNested.vue"
import ResponseInfo from '@/components/ResponseInfo.vue'
import NewParentNavigationModal from '@/components/MenuBuilder/NewParentNavigationModal.vue'
import DeleteLinkConfrimationModal from '@/components/MenuBuilder/DeleteLinkConfrimationModal.vue'
import MenuBuilderInstructionsModal from '@/components/MenuBuilder/MenuBuilderInstructionsModal.vue'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: "MenuBuilder",
  data() {
    return {
      overlayActive: false,
      userLevels: [], //
      currentUserLevel: '', //
      importUserLevel: '',
      navigationArray: [],
      importNavigationArray: [],
      selectedKeys: [],
      nav1: [], //
      nav2: [], //
      importNav: [],
      importNavBox: false,
      isBusy: false,
      parentActiveNavigation: [],
      parentInactiveNavigation: [],
      parentId1: 0,
      parentId2: 0,
      navLinkId: 0,
      navLinkName: '',
      importUserLevelName: null
    }
  },
  components: {
    MenuNested,
    ResponseInfo,
    draggable,
    NewParentNavigationModal,
    DeleteLinkConfrimationModal,
    MenuBuilderInstructionsModal
  },
  computed: {
     ...mapGetters(['getResponseInfo']),
    checkNestLevel() {
      let self = this
      this.myArray.forEach( function (el) {
        if(el.elements.length > 0) {
          el.elements.forEach( function (e) {
            if(e.elements.length > 0) {
              if(!self.block.includes(e.name)) {
                self.block.push(e.name)
              }
              return false
            } else {
              self.block.pop(e.name)
            }
          })
        }
      })

      return true
    },
    dragOptions() {
      return {
        animation: 200,
        group: "navigation",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    disableOverlay() {
      this.overlayActive = false
    },
    openNewParentModal() {
      this.overlayActive = true
      this.$refs.newParentLinkModal.clearData()
      this.$root.$emit('bv::show::modal', 'newParentLink')
    },
    openInstructionsModal() {
      this.overlayActive = true
      this.$root.$emit('bv::show::modal', 'menuBuilderInstructions')
    },
    getNavigation() {
      this.nav1 = []
      this.nav2 = []
      this.selectedKeys = []
      this.importNavBox = false
      this.parentActiveNavigation = []
      this.parentInactiveNavigation = []

      let allButtons = document.querySelectorAll(".btn-subnavigation")

      allButtons.forEach(function(el) {
        el.classList.remove("btn-success")
      })

      this.$store.dispatch('menuBuilderStore/getNavigation', 
      {
        userLevel: this.currentUserLevel
      }).then(response => {
        this.navigationArray = response.navigation
        this.userLevels = response.userLevels
        for (const el of  Object.keys(this.navigationArray)) {
          var parent = {
            id: this.navigationArray[el].id,
            active: this.navigationArray[el].active,
            position: this.navigationArray[el].position,
            item_name: this.navigationArray[el].item_name,
            item_key: el
          }

          if(this.navigationArray[el].active == 1) {
            this.parentActiveNavigation.push(parent)
          } else {
            this.parentInactiveNavigation.push(parent)
          }
        }
      })
    },
    importNavigation(event) {
      if(event.target.options[event.target.options.selectedIndex].text) {
        this.importUserLevelName = event.target.options[event.target.options.selectedIndex].text
      }
      
      if(this.importUserLevel) {
        this.$store.dispatch('menuBuilderStore/getNavigation', 
        {
          userLevel: this.importUserLevel
        }).then(response => {
          this.importNavigationArray = response.navigation
        })
      } else {
        this.importNavigationArray = []
        this.importNav = []
      }
    },
    closeImportBox() {
      this.importNavigationArray = []
      this.importNav = []
      this.importNavBox = false
    },
    displaySubNavigation(parent, parentId) {    
      if(this.selectedKeys.includes(parent)) {
        let index = this.selectedKeys.indexOf(parent)
        this.selectedKeys.splice(index, 1)
      } else {       
        this.selectedKeys.push(parent)
      }

      if(this.selectedKeys.length > 2) {
        this.selectedKeys.shift()
        // second parent now becomes the first one
        this.parentId1 = this.parentId2
        this.parentId2 = parentId
      } else if(this.selectedKeys.length == 1) {
        this.parentId1 = parentId
      } else if(this.selectedKeys.length == 2) {
        this.parentId2 = parentId
      }
      
      let self = this
      this.nav1 = []
      this.nav2 = []

      if(this.selectedKeys[0]) {
        let menu = this.objectToArray(this.navigationArray[this.selectedKeys[0]].menu)
        menu.forEach(function (el) {
          self.nav1.push(el)
        })
      }

      if(this.nav1.length < 4 && this.selectedKeys[0]) {
        for(length = this.nav1.length; length < 4; length++) {
          this.nav1.push([])
        }
      }

      if(this.selectedKeys[1]) {
        let menu = this.objectToArray(this.navigationArray[this.selectedKeys[1]].menu)
        menu.forEach(function (el) {
          self.nav2.push(el)
        })
      }

      if(this.nav2.length < 4 && this.selectedKeys[1]) {
        for(length = this.nav2.length; length < 4; length++) {
          this.nav2.push([])
        }
      }
    },

    displayImportNavigation(event, parent, parentId) {
      let allButtons = document.querySelectorAll(".btn-import")

      allButtons.forEach(function(el) {
        el.classList.remove("btn-success")
      })

      event.target.classList.add("btn-success")
      let self = this
      this.importNav = []

      if(parent) {
        let menu = this.objectToArray(this.importNavigationArray[parent].menu)
        menu.forEach(function (el) {
          self.importNav.push(el)
        })
      }

      if(this.importNav.length < 4 && parent) {
        for(length = this.importNav.length; length < 4; length++) {
          this.importNav.push([])
        }
      }
    },

    objectToArray(object) {
      var arr  = [],
      keys = Object.keys(object);

      for(var i=0,n=keys.length;i<n;i++){
        var key  = keys[i];
        arr[key] = object[key];
      }

      arr.shift()
      return arr
    },
    updateNavigation() {
      this.isBusy = true
      this.$store.dispatch('menuBuilderStore/updateNavigation', {
        navigation1: this.nav1,
        navigation2: this.nav2,
        selectedKeys: this.selectedKeys,
        userLevel: this.currentUserLevel,
        parentActiveNavigation: this.parentActiveNavigation,
        parentInactiveNavigation: this.parentInactiveNavigation
      }).then(response => {
        this.isBusy = false
        this.importNavBox = false
        this.importNavigationArray = []
      })
    },
    toggleImport() {
      this.importNavBox = this.importNavBox ? false : true
    },
    deleteLink(linkId, linkName) {
      this.navLinkId = linkId
      this.navLinkName = linkName
      this.overlayActive = true
      this.$root.$emit('bv::show::modal', 'deleteNavLink')
    }
  },
  created() {
    this.getNavigation()

    // clear response box when you arrive to the website
    this.$store.dispatch('alertClearResponse')
  }
};
</script>

<style scoped>
.list-group {
  display: inline-block !important;
}
.whitespace {
  white-space: inherit;
}
</style>
